import { SessionHandler } from "./SessionHandler.js";
import { ThirdPartyDevice } from "verdi-common/schemas/thirdPartyDevice/thirdPartyDevice";
export class ThirdPartyDeviceAPI {
    /**
     * Creates a device based on the provided parameters
     */
    static async addOne(args: ThirdPartyDevice): Promise<ThirdPartyDevice> {
        const url = "thirdPartyDevices/register";
        const body = {
            ...args,
        };
        const response = await SessionHandler.doFetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify(body),
        });
        if (response.ok) {
            return await response.json();
        } else {
            const json = await response.json();
            throw new Error({ ...json });
        }
    }

    /**
     * Delete a single device based on it's ID
     * @param devId ID of device to delete
     */
    static async deleteOne(devId: string): Promise<boolean> {
        await SessionHandler.doFetch("thirdPartyDevices/" + devId, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "DELETE",
            redirect: "follow",
        });
        return true;
    }
    /**
     * Gets the information for a single device
     */
    static async editOne(id: string, args: Partial<ThirdPartyDevice>): Promise<ThirdPartyDevice> {
        const response = await SessionHandler.doFetch("thirdPartyDevices/edit/" + id, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify({
                ...args,
            }),
        });
        return await response.json();
    }
}
